import axios from 'axios';

const api = '/api/contracts';

export const getContractStructureByProductType = productType => {
  return axios.get(`${api}/structure/${productType}?cacheBuster=${new Date().getTime()}`);
};

export const createContract = data => {
  return axios.post(`${api}?cacheBuster=${new Date().getTime()}`, data);
};

export const updateContract = (id, data) => {
  return axios.put(`${api}/${id}?cacheBuster=${new Date().getTime()}`, data);
};

export const updateContractPaymentTemplate = (id, data) => {
  return axios.put(`${api}/contract-template/${id}?cacheBuster=${new Date().getTime()}`, data);
};

export const getContractById = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const getContractLightById = id => {
  return axios.get(`${api}/light/${id}?cacheBuster=${new Date().getTime()}`);
};

export const searchContracts = params => {
  return axios.post(`${api}/search${params}&cacheBuster=${new Date().getTime()}`);
};

export const getContractPaymentsById = id => {
  return axios.get(`${api}/payments/${id}?cacheBuster=${new Date().getTime()}`);
};

export const addContractPaymentOutsideImportedPayment = (id, contract) => {
  return axios.post(`${api}/contract-payment/${id}?cacheBuster=${new Date().getTime()}`, contract);
};

export const updateContractPayment = (id, contract) => {
  return axios.put(`${api}/contract-payment/${id}?cacheBuster=${new Date().getTime()}`, contract);
};

export const sendCiastocnyVyber = (id, data) => {
  return axios.put(`${api}/${id}/ciastocny-vyber?cacheBuster=${new Date().getTime()}`, data);
};

export const deleteContractPayment = id => {
  return axios.delete(`${api}/contract-payment/${id}?cacheBuster=${new Date().getTime()}`);
};

export const getClientContracts = () => {
  return axios.get(`${api}/client-contracts?cacheBuster=${new Date().getTime()}`);
};

export const getClientContractById = id => {
  return axios.get(`${api}/client-contracts/${id}?cacheBuster=${new Date().getTime()}`);
};

export const getContractHistory = id => {
  return axios.get(`${api}/history/${id}?cacheBuster=${new Date().getTime()}`);
};

export const getProvisionSheetsForContract = id => {
  return axios.get(`/api/provisions/contract/${id}/sheets?cacheBuster=${new Date().getTime()}`);
};
